export { default } from "./CategoryMenuStrapi";
